import { render, staticRenderFns } from "./LinkTenantSetting.vue?vue&type=template&id=a359c09a&scoped=true"
import script from "./LinkTenantSetting.vue?vue&type=script&lang=js"
export * from "./LinkTenantSetting.vue?vue&type=script&lang=js"
import style0 from "./LinkTenantSetting.vue?vue&type=style&index=0&id=a359c09a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a359c09a",
  null
  
)

export default component.exports